<template>
  <div class="service_in">
    <el-divider content-position="left">服务事项录入</el-divider>
    <div style="display: flex">
      <el-select v-model="searchForm.companyId" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司" size="mini"
        clearable :remote-method="searchRemoteCompanyMethodS" :loading="searchLoading" @change="toSearch">
        <el-option v-for="searchCompany in searchCompaniesx" :key="searchCompany.id" :label="searchCompany.company_name"
          :value="searchCompany.id">
        </el-option>
      </el-select>
      <el-date-picker v-model="searchForm.created_at" type="daterange" align="right" unlink-panels range-separator="至"
        start-placeholder="创建日期开始" end-placeholder="创建日期结束" :picker-options="searchPickerOptions"
        :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" size="mini" @change="toLoadTable"
        style="margin-left: 0.2rem">
      </el-date-picker>
      <el-date-picker v-model="searchForm.handle_at" type="daterange" align="right" unlink-panels range-separator="至"
        start-placeholder="办理日期开始" end-placeholder="办理日期结束" :picker-options="searchPickerOptions"
        :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" size="mini" @change="toLoadTable"
        style="margin-left: 0.2rem">
      </el-date-picker>
      <el-popover placement="bottom" width="570" trigger="click">
        <el-form ref="searchForm" :model="searchForm" label-width="85px" style="padding-right: 0.63rem" class="search">
          <div style="display: inline-block; width: 315px">
            <div style="text-align: center; margin-left: 80px">基础筛选</div>
            <el-form-item label="创建人" prop="typeiner_id">
              <el-cascader style="width: 100%" v-model="searchForm.typeiner_id" placeholder="请选择"
                :options="typeinerOptions" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                filterable @click.native="loadTypeiner">
              </el-cascader>
              <!--             
              <el-select v-model="searchForm.typeiner_id" clearable placeholder="请选择" size="mini" filterable
                @click.native="loadTypeiner" style="width: 100%">
                <el-option v-for="item in typeinerOptions" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="办理人" prop="doner_id">
              <el-cascader style="width: 100%" v-model="searchForm.doner_id" placeholder="请选择" :options="donerOptions"
                size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                @click.native="loadDoner">
              </el-cascader>
              <!-- <el-select v-model="searchForm.doner_id" clearable placeholder="请选择" size="mini" filterable
                @click.native="loadDoner" style="width: 100%">
                <el-option v-for="item in donerOptions" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="外勤办理人" prop="doner_id_w">
              <el-cascader style="width: 100%" v-model="searchForm.doner_id_w" placeholder="请选择" :options="donerOptions"
                size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                @click.native="loadDoner">
              </el-cascader>
              <!-- <el-select v-model="searchForm.doner_id_w" clearable placeholder="请选择" size="mini" filterable
                @click.native="loadDoner" style="width: 100%">
                <el-option v-for="item in donerOptions" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="分配人" prop="dis_id">
              <el-cascader style="width: 100%" v-model="searchForm.dis_id" placeholder="请选择" :options="diserOptions"
                size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                @click.native="loadDiser">
              </el-cascader>
              <!-- <el-select v-model="searchForm.dis_id" clearable placeholder="请选择" size="mini" filterable
                @click.native="loadDiser" style="width: 100%">
                <el-option v-for="item in diserOptions" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="共享人" prop="share_id">
              <el-cascader style="width: 100%" v-model="searchForm.share_id" placeholder="请选择" :options="sharerOptions"
                size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                @click.native="loadSharer">
              </el-cascader>
              <!-- <el-select v-model="searchForm.share_id" clearable placeholder="请选择" size="mini" filterable
                @click.native="loadSharer" style="width: 100%">
                <el-option v-for="item in sharerOptions" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="分类" prop="category_id">
              <el-select v-model="searchForm.category_id" clearable placeholder="请选择" size="mini" filterable
                @click.native="loadCategory_id" @change="loadSchedule_id" style="width: 100%">
                <el-option v-for="item in category_idOptions" :key="item.id" :label="item.category_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="事项" prop="schedule_id">
              <el-select v-model="searchForm.schedule_id" clearable placeholder="请选择" size="mini" filterable
                style="width: 100%">
                <!-- @click.native="loadSchedule_id" -->
                <el-option v-for="item in schedule_idOptions" :key="item.id" :label="item.title" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-table-column prop="detail_in" label="事项详请" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="remark" label="事项备注" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="" label="办事地点" width="180" show-overflow-tooltip>
              <template slot-scope="scope" v-if="scope.row.place">
                <p style="color: #409eff;">{{ scope.row.place.places_title }}</p>
                <p style="color: #e6a23c">{{ scope.row.place.address }}</p>
              </template>
            </el-table-column>
            <el-form-item label="进度" prop="progress">
              <el-radio-group v-model="searchForm.progress" size="mini" @change="progressClear">
                <el-radio-button :label="'d'">待分配</el-radio-button>
                <el-radio-button :label="'i'">进行中</el-radio-button>
                <el-radio-button :label="'y'">已完成</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="完成日期" prop="done_at" v-if="searchForm.progress === 'y'">
              <el-date-picker v-model="searchForm.done_at" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="searchPickerOptions" :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss" size="mini" style="width: 100%">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="searchForm.status" size="mini">
                <el-radio-button :label="'n'">正常</el-radio-button>
                <el-radio-button :label="'p'">暂停</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="服务类型" prop="type">
              <el-radio-group v-model="searchForm.type" size="mini">
                <el-radio-button :label="'n'">内勤</el-radio-button>
                <el-radio-button :label="'w'">外勤</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: inline-block; width: 220px; float: right">
            <div style="text-align: center">查询人员服务的公司</div>
            <el-form-item label-width="0" prop="businessC">
              <el-cascader style="width: 100%" v-model="searchForm.businessC" placeholder="选择业务员查询服务的公司"
                :options="businessOptionsC" size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" clearable filterable
                @click.native="loadAdminBusC">
              </el-cascader>
              <!-- <el-select v-model="searchForm.businessC" clearable placeholder="选择业务员查询服务的公司" size="mini" filterable
                @click.native="loadAdminBusC" style="width: 100%">
                <el-option v-for="item in businessOptionsC" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label-width="0" prop="kefuC">
              <el-cascader style="width: 100%" v-model="searchForm.kefuC" placeholder="选择客服会计查询服务的公司"
                :options="kefuOptionsC" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                filterable @click.native="loadAdminKefuC">
              </el-cascader>
              <!-- <el-select v-model="searchForm.kefuC" clearable placeholder="选择客服会计查询服务的公司" size="mini" filterable
                @click.native="loadAdminKefuC" style="width: 100%">
                <el-option v-for="item in kefuOptionsC" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label-width="0" prop="jizhangC">
              <el-cascader style="width: 100%" v-model="searchForm.jizhangC" placeholder="选择理票会计查询服务的公司"
                :options="jizhangOptionsC" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                filterable @click.native="loadAdminJizhangC">
              </el-cascader>
              <!-- <el-select v-model="searchForm.jizhangC" clearable placeholder="选择理票会计查询服务的公司" size="mini" filterable
                @click.native="loadAdminJizhangC" style="width: 100%">
                <el-option v-for="item in jizhangOptionsC" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label-width="0" prop="taxC">
              <el-cascader style="width: 100%" v-model="searchForm.taxC" placeholder="选择记账报税会计查询服务的公司"
                :options="taxOptionsC" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                filterable @click.native="loadAdminTaxC">
              </el-cascader>
              <!-- <el-select v-model="searchForm.taxC" clearable placeholder="选择记账报税会计查询服务的公司" size="mini" filterable
                @click.native="loadAdminTaxC" style="width: 100%">
                <el-option v-for="item in taxOptionsC" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label-width="0" prop="kaipiaoC">
              <el-cascader style="width: 100%" v-model="searchForm.kaipiaoC" placeholder="选择开票会计查询服务的公司"
                :options="kaipiaoOptionsC" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                filterable @click.native="loadAdminKaipiaoC">
              </el-cascader>
              <!-- <el-select v-model="searchForm.kaipiaoC" clearable placeholder="选择开票会计查询服务的公司" size="mini" filterable
                @click.native="loadAdminKaipiaoC" style="width: 100%">
                <el-option v-for="item in kaipiaoOptionsC" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label-width="0" prop="leaderC">
              <el-cascader style="width: 100%" v-model="searchForm.leaderC" placeholder="选择财税负责人查询服务的公司"
                :options="leaderOptionsC" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                filterable @click.native="loadAdminLeaderC">
              </el-cascader>
              <!-- <el-select v-model="searchForm.leaderC" clearable placeholder="选择财税负责人查询服务的公司" size="mini" filterable
                @click.native="loadAdminLeaderC" style="width: 100%">
                <el-option v-for="item in leaderOptionsC" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
          </div>
          <div style="text-align: right">
            <el-button type="info" @click="resetForm('searchForm')" size="mini">重置</el-button>
            <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
          </div>
        </el-form>
        <el-button slot="reference" size="mini" style="margin-left: 10px">筛选</el-button>
      </el-popover>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="serviceIn">录入</el-button>
      </div>
    </div>
    <div></div>
    <el-collapse v-model="activeNames" style="border-top: none" id="servicein">
      <!-- <el-collapse-item title="" name="1">
        <template slot="title">
          <span style="color: #409eff">数据统计</span>
        </template>
        <el-row style="margin-top: 0.2rem; font-size: 0.38rem" :gutter="20">
          <el-col :span="3">
            <el-card
              style="border-left: 4px solid; border-radius: 0; color: #f56c6c"
            >
              <p>未分配:</p>
              <p style="margin-top: 0.15rem; color: #f56c6c">
                {{ header.undis }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p>进行中:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ header.ing }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #67c23a; border-radius: 0">
              <p>已完成:</p>
              <p style="color: #67c23a; margin-top: 0.15rem">{{ header.al }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid; border-radius: 0">
              <p style="white-space: nowrap">累计事项:</p>
              <p style="color: ; margin-top: 0.15rem">{{ total }}</p>
            </el-card>
          </el-col>
        </el-row>
        <el-row style="margin-top: 0.2rem" :gutter="20">
          <el-col :span="3">
            <el-tag size="mini">今日:</el-tag>
          </el-col>
          <el-col :span="3" :offset="6">
            <el-tag size="mini">本月:</el-tag>
          </el-col>
        </el-row>
        <el-row style="font-size: 0.38rem" :gutter="20">
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p style="white-space: nowrap">今日事项:</p>
              <p style="margin-top: 0.15rem; color: #409eff">
                {{ header.today }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #67c23a; border-radius: 0">
              <p style="white-space: nowrap">新建完成:</p>
              <p style="color: #67c23a; margin-top: 0.15rem">
                {{ header.today_al }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid; border-radius: 0">
              <p style="white-space: nowrap">累计完成:</p>
              <p style="color: ; margin-top: 0.15rem">
                {{ header.today_al_total }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #e6a23c; border-radius: 0">
              <p style="white-space: nowrap">本月创建:</p>
              <p style="color: #e6a23c; margin-top: 0.15rem">
                {{ header.month }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #f56c6c; border-radius: 0">
              <p style="white-space: nowrap">新建未完成:</p>
              <p style="color: #f56c6c; margin-top: 0.15rem">
                {{ header.month_not }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #67c23a; border-radius: 0">
              <p style="white-space: nowrap">累计完成:</p>
              <p style="color: #67c23a; margin-top: 0.15rem">
                {{ header.month_total }}
              </p>
            </el-card>
          </el-col>
        </el-row>
        <el-row style="margin-top: 0.2rem; font-size: 0.38rem" :gutter="20">
          <el-col :span="3">
            <el-card style="border-left: 4px solid #f56c6c; border-radius: 0">
              <p style="white-space: nowrap">分配超时:</p>
              <p style="color: #f56c6c; margin-top: 0.15rem">
                {{ header.dis_out }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #f56c6c; border-radius: 0">
              <p style="white-space: nowrap">办理超时:</p>
              <p style="color: #f56c6c; margin-top: 0.15rem">
                {{ header.done_out }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #e6a23c; border-radius: 0">
              <p style="white-space: nowrap">暂停:</p>
              <p style="color: #e6a23c; margin-top: 0.15rem">
                {{ header.pause }}
              </p>
            </el-card>
          </el-col>
        </el-row>
        <el-row style="margin-top: 0.2rem; font-size: 0.38rem" :gutter="20">
          <el-col :span="4">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p style="white-space: nowrap">我办理的事项:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ header.my }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card style="border-left: 4px solid; border-radius: 0">
              <p style="white-space: nowrap">关联公司事项:</p>
              <p style="color: ; margin-top: 0.15rem">
                {{ header.my_relevance }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card style="border-left: 4px solid #e6a23c; border-radius: 0">
              <p style="white-space: nowrap">我分配的事项:</p>
              <p style="color: #e6a23c; margin-top: 0.15rem">
                {{ header.my_dis }}
              </p>
            </el-card>
          </el-col>
        </el-row>
      </el-collapse-item> -->
      <el-collapse-item title="" name="2">
        <template slot="title">
          <span style="color: #409eff">数据统计</span>
        </template>
        <!-- <div style="background-color: #f5f6f7">
          <div style="background-color: #ffffff; padding: 0.2rem 0">
            <el-card shadow="hover" style="border: none">
              <el-row style="font-size: 0.3rem" :gutter="0">
                <el-col>
                  <el-col
                    :span="2"
                    style="
                      border-right: 1px solid #dcdfe6;
                      text-align: center;
                      color: #909399;
                      padding: 0.3rem 0;
                    "
                  >
                    <el-row style="font-size: 0.33rem">
                      <el-col>总事项</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >未分配</el-col
                      >
                      <el-col :span="10" style="color: #f56c6c">{{
                        header.undis
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >进行中</el-col
                      >
                      <el-col :span="10" style="color: #409eff">{{
                        header.ing
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >已完成</el-col
                      >
                      <el-col :span="10" style="color: #67c23a">{{
                        header.al
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >累计</el-col
                      >
                      <el-col :span="10" style="color: ">{{ total }}</el-col>
                    </el-row>
                  </el-col>
                  <el-col
                    :span="3"
                    style="
                      border-right: 1px solid #dcdfe6;
                      text-align: center;
                      color: #909399;
                      padding: 0.3rem 0;
                    "
                  >
                    <el-row style="font-size: 0.33rem">
                      <el-col>今日事项</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >创建</el-col
                      >
                      <el-col :span="10" style="color: ">{{
                        header.today
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >新建完成</el-col
                      >
                      <el-col :span="10" style="color: #67c23a">{{
                        header.today_al
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >累计完成</el-col
                      >
                      <el-col :span="10" style="color: ">{{
                        header.today_al_total
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >&nbsp;</el-col
                      >
                      <el-col :span="10" style="color: ">&nbsp;</el-col>
                    </el-row>
                  </el-col>
                  <el-col
                    :span="3"
                    style="
                      border-right: 1px solid #dcdfe6;
                      text-align: center;
                      color: #909399;
                      padding: 0.3rem 0;
                    "
                  >
                    <el-row style="font-size: 0.33rem">
                      <el-col>本月事项</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >创建</el-col
                      >
                      <el-col :span="10" style="color: #e6a23c">{{
                        header.month
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >新建未完成</el-col
                      >
                      <el-col :span="10" style="color: #f56c6c">{{
                        header.month_not
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >累计完成</el-col
                      >
                      <el-col :span="10" style="color: #67c23a">{{
                        header.month_total
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >&nbsp;</el-col
                      >
                      <el-col :span="10" style="color: ">&nbsp;</el-col>
                    </el-row>
                  </el-col>
                  <el-col
                    :span="3"
                    style="
                      border-right: 1px solid #dcdfe6;
                      text-align: center;
                      color: #909399;
                      padding: 0.3rem 0;
                    "
                  >
                    <el-row style="font-size: 0.33rem">
                      <el-col>事项状态</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >分配超时</el-col
                      >
                      <el-col :span="10" style="color: #f56c6c">{{
                        header.dis_out
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >办理超时</el-col
                      >
                      <el-col :span="10" style="color: #f56c6c">{{
                        header.done_out
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >暂停</el-col
                      >
                      <el-col :span="10" style="color: #e6a23c">{{
                        header.pause
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="4" style="white-space: nowrap"></el-col>
                      <el-col :span="3" style="color: #67c23a">&nbsp;</el-col>
                    </el-row>
                  </el-col>
                  <el-col
                    :span="4"
                    style="
                      border-right: 1px solid #dcdfe6;
                      text-align: center;
                      color: #909399;
                      padding: 0.3rem 0;
                    "
                  >
                    <el-row style="font-size: 0.33rem">
                      <el-col>我的事项</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >我办理的事项</el-col
                      >
                      <el-col :span="10" style="color: #409eff">{{
                        header.my
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >关联公司事项</el-col
                      >
                      <el-col :span="10" style="color: ">{{
                        header.my_relevance
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="10" style="white-space: nowrap"
                        >我分配的事项</el-col
                      >
                      <el-col :span="10" style="color: #e6a23c">{{
                        header.my_dis
                      }}</el-col>
                    </el-row>
                    <el-row type="flex" justify="center" :gutter="40">
                      <el-col :span="4" style="white-space: nowrap"></el-col>
                      <el-col :span="3" style="color: #67c23a">&nbsp;</el-col>
                    </el-row>
                  </el-col>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </div> -->
        <el-row :gutter="12">
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">总事项</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row type="flex" justify="center" :gutter="12" class="item-row" style="color: #f56c6c">
                    <el-col :span="14" style="white-space: nowrap">未分配</el-col>
                    <el-col :span="10" style="color: #f56c6c">{{ header.undis }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" justify="center" :gutter="12" style="color: #409eff">
                    <el-col :span="14" style="white-space: nowrap">进行中</el-col>
                    <el-col :span="10" style="color: #409eff">{{ header.ing }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" justify="center" :gutter="12" style="color: #67c23a">
                    <el-col :span="14" style="white-space: nowrap">已完成</el-col>
                    <el-col :span="10" style="color: #67c23a">{{ header.al }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: " justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">累计</el-col>
                    <el-col :span="10" style="color: ">{{ total }}</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">今日事项</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row type="flex" class="item-row" style="color: #409eff" justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">创建</el-col>
                    <el-col :span="10" style="color: ">{{ header.today }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: #67c23a" justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">新建完成</el-col>
                    <el-col :span="10" style="color: #67c23a">{{
        header.today_al
      }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: " justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">累计完成</el-col>
                    <el-col :span="10" style="color: ">{{
        header.today_al_total
      }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: " justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">&nbsp;</el-col>
                    <el-col :span="10" style="color: ">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">本月事项</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row type="flex" class="item-row" style="color: #409eff" justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">创建</el-col>
                    <el-col :span="10" style="color: ">{{ header.month }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: #f56c6c" justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">新建未完成</el-col>
                    <el-col :span="10" style="color: #f56c6c">{{
        header.month_not
      }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: " justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">累计完成</el-col>
                    <el-col :span="10" style="color: ">{{ header.month_total }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: " justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">&nbsp;</el-col>
                    <el-col :span="10" style="color: ">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">事项状态</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row type="flex" class="item-row" style="color: #f56c6c" justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">分配超时</el-col>
                    <el-col :span="10" style="color: #f56c6c">{{
        header.dis_out
      }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: #f56c6c" justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">办理超时</el-col>
                    <el-col :span="10" style="color: #f56c6c">{{
        header.done_out
      }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: #e6a23c" justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">暂停</el-col>
                    <el-col :span="10" style="color: #e6a23c">{{ header.pause }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: " justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap"></el-col>
                    <el-col :span="10" style="color: #67c23a">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">我的事项</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row type="flex" class="item-row" style="color: #409eff" justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">我办理的事项</el-col>
                    <el-col :span="10" style="color: #409eff">{{ header.my }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: #e6a23c" justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">关联公司事项</el-col>
                    <el-col :span="10" style="color: ">{{ header.my_relevance }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: " justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap">我分配的事项</el-col>
                    <el-col :span="10" style="color: ">{{ header.my_dis }}</el-col>
                  </el-row>
                  <el-row type="flex" class="item-row" style="color: " justify="center" :gutter="12">
                    <el-col :span="14" style="white-space: nowrap"></el-col>
                    <el-col :span="10" style="color: ">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
    <!-- <el-row style="margin-top: 0.2rem" :gutter="0">
      <el-col :span="3" style="color: #e6a23c">
        <span>未分配:</span>
        <span style="color: ">{{ header.undis }}</span>
      </el-col>
      <el-col :span="3" style="color: #409eff">
        <span>进行中:</span>
        <span style="color: ">{{ header.ing }}</span>
      </el-col>
      <el-col :span="3" style="color: #67c23a">
        <span>已完成:</span>
        <span>{{ header.al }}</span>
      </el-col>
      <el-col :span="3" style="color: ">
        <span>累计事项:</span>
        <span>{{ total }}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.2rem" :gutter="0">
      <el-col :span="3" style="color: ">
        <span>今日事项:</span>
        <span>{{ header.today }}</span>
      </el-col>
      <el-col :span="3" style="color: #67c23a">
        <span>今日新建完成:</span>
        <span>{{ header.today_al_total }}</span>
      </el-col>
      <el-col :span="3" style="color: ">
        <span>今日累计完成:</span>
        <span>{{ header.today_al_total }}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.2rem" :gutter="0">
      <el-col :span="3" style="color: ">
        <span>本月创建:</span>
        <span>{{ header.month }}</span>
      </el-col>
      <el-col :span="3" style="color: #e6a23c">
        <span>本月新建未完成:</span>
        <span>{{ header.month_not }}</span>
      </el-col>
      <el-col :span="3" style="color: #67c23a">
        <span>本月累计完成:</span>
        <span>{{ header.month_total }}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.2rem" :gutter="0">
      <el-col :span="3" style="color: #f56c6c">
        <span>分配超时:</span>
        <span>{{ header.dis_out }}</span>
      </el-col>
      <el-col :span="3" style="color: #f56c6c">
        <span>办理超时:</span>
        <span>{{ header.done_out }}</span>
      </el-col>
      <el-col :span="3" style="color: #e6a23c">
        <span>暂停:</span>
        <span>{{ header.pause }}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.2rem" :gutter="0">
      <el-col :span="3" style="color: #409eff">
        <span>我办理的事项:</span>
        <span>{{ header.my }}</span>
      </el-col>
      <el-col :span="3" style="color: #e6a23c">
        <span>关联公司事项:</span>
        <span>{{ header.my_relevance }}</span>
      </el-col>
      <el-col :span="3" style="color: ">
        <span>我分配的事项:</span>
        <span>{{ header.my_dis }}</span>
      </el-col>
    </el-row> -->
    <el-drawer title="" :visible.sync="imageDrawer" direction="rtl" size="40%">
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem">截图/文件</span>
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <div class="block">
          <el-timeline>
            <el-timeline-item placement="top">
              <el-card>
                <div v-for="item in imageData" :key="item.id">
                  <div v-if="item.type === 'img'" style="margin-bottom: 0.3rem">
                    <p style="margin-bottom: 0.28rem">
                      <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                        <span style="
                            display: block;
                            width: 2.5rem;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          ">{{ item.name }}</span>
                      </el-tooltip>
                    </p>
                    <p>
                      <img @click="reSizePic(item.url)" :src="item.url" width="150px" height="150px"
                        style="cursor: pointer" />
                    </p>
                  </div>
                  <div v-if="item.type === 'file'">
                    <p style="margin-bottom: 0.28rem">
                      <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                        <span style="
                            display: block;
                            width: 2.5rem;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          " v-down="item.url">
                          <el-link style="color: #409eff">{{ item.name }}</el-link>
                        </span>
                      </el-tooltip>
                    </p>
                    <!-- <p>
                          <img :src="i.url" width="150px" height="150px" />
                        </p> -->
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
    <el-drawer title="订单信息" :visible.sync="orderInfoVisible" direction="rtl" size="50%"
      :before-close="handleOrderInfoClose">
      <div style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId" @changeOrder="changeOrder"></order-info>
      </div>
    </el-drawer>
    <el-drawer title="公司信息" :visible.sync="companyInfoDrawer" direction="rtl" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyComId" :checkType="pendCheckType"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="企业微信聊天记录" :visible.sync="wxChatDrawer" direction="rtl" :before-close="handleWxChatBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkchatCompany"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="电话联系记录" :visible.sync="callLogsDrawer" direction="rtl" :before-close="handleCallLogsBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs :company="company" :phone="callPhone" :phone1="callPhone1" :phone2="callPhone2"
            :phone3="callPhone3"></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer :visible.sync="editDrawer" direction="rtl" :before-close="handleClose_edit" size="40%">
      <template slot="title">
        <span style="font-size: 0.38rem; font-weight: 700; color: #409eff">修改</span>
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form :model="editForm" :rules="rules_edit" ref="editForm" label-width="100px">
          <el-form-item label="公司名称" prop="company_id">
            <el-select v-model="editForm.company_id" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司"
              size="mini" clearable :disabled="true" :remote-method="searchRemoteCompanyMethod" :loading="searchLoading"
              style="width: 100%">
              <el-option v-for="searchCompany in searchCompanies" :key="searchCompany.id"
                :label="searchCompany.company_name" :value="searchCompany.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成时间" prop="completed_at">
            <el-date-picker v-model="editForm.completed_at" type="datetimerange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="typeInPickerOptions"
              :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"
              size="mini">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="事项类型" prop="type">
            <el-checkbox v-model="editForm.type" size="mini" label="w" border @change="clearNot_edit">是否包含外勤
            </el-checkbox>
          </el-form-item>
          <el-form-item label="紧急程度" prop="urgent">
            <el-radio-group v-model="editForm.urgent" size="mini">
              <el-radio-button label="1">正常</el-radio-button>
              <el-radio-button label="2">紧急</el-radio-button>
              <el-radio-button label="3">非常紧急</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="难易程度" prop="easy">
            <el-radio-group v-model="editForm.easy" size="mini">
              <el-radio-button label="1">容易</el-radio-button>
              <el-radio-button label="2">正常</el-radio-button>
              <el-radio-button label="3">困难</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="事项分类" prop="categoryId">
            <el-select v-model="editForm.categoryId" placeholder="请选择" clearable filterable size="mini"
              style="width: 100%" @click.native="loadCategory" @change="loadTitle($event, true)">
              <el-option v-for="item in categoryIdOptions" :key="item.id" :label="item.category_name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事项内容" prop="title">
            <el-select v-model="editForm.title" placeholder="请选择" multiple clearable filterable size="mini"
              style="width: 100%" @change="changeTitle_edit">
              <!-- @click.native="loadTitle" -->
              <el-option v-for="item in titleIdOptions" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内部可见" prop="detail_in">
            <el-input size="mini" type="textarea" v-model="editForm.detail_in" placeholder="内容详情"
              style="white-space: pre"></el-input>
          </el-form-item>
          <el-form-item label="外部可见" prop="detail_out">
            <el-input size="mini" type="textarea" v-model="editForm.detail_out" placeholder="内容详情"></el-input>
          </el-form-item>
          <el-form-item label="办理人" prop="doner_id">
            <el-cascader style="width: 100%" v-model="editForm.doner_id" placeholder="请选择" :options="adminUserOptions"
              size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
              @click.native="loadAdminUser">
            </el-cascader>
            <!-- <el-select v-model="editForm.doner_id" placeholder="请选择" size="mini" @click.native="loadAdminUser" filterable
              style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="外勤办理人" prop="doner_id_w" v-if="editForm.type">
            <el-cascader style="width: 100%" v-model="editForm.doner_id_w" placeholder="请选择"
              :options="adminUserOptions_w" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
              filterable @click.native="loadAdminUserForW">
            </el-cascader>
            <!-- <el-select v-model="editForm.doner_id_w" placeholder="请选择" size="mini" @click.native="loadAdminUserForW"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions_w" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="办事地点" prop="address" v-if="editForm.type">
            <el-select v-model="editForm.address" placeholder="请选择" size="mini" @click.native="loadPlace" filterable
              style="width: 100%" clearable>
              <el-option v-for="item in placeOptions" :key="item.id" :label="item.places_title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事项备注" prop="remark">
            <el-input size="mini" type="textarea" v-model="editForm.remark" placeholder="内容详情"></el-input>
          </el-form-item>
          <el-form-item label="补充信息">
            <el-collapse v-model="activeNames_in_edit">
              <el-collapse-item title="" name="1">
                <template slot="title">
                  <span style="color: #409eff">点击打开/隐藏</span>
                </template>
                <el-form-item label="订单号" prop="order_num">
                  <el-input v-model="editForm.order_num" size="mini" placeholder="请输入订单号" @input="getOrder"></el-input>
                  <el-row v-if="orderData" :gutter="0">
                    <el-row>
                      <el-col>
                        <span>订单号：</span>
                        <span style="color: #409eff">{{ this.orderData.order_num }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>创建时间：</span>
                        <span>{{ this.orderData.created_at }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>订单类型：</span>
                        <span style="color: #e6a23c">{{
        this.orderData.order_type
      }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>转化人：</span>
                        <span style="color: #67c23a">{{
        this.orderData.convert_name
      }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>订单总金额：</span>
                        <span style="color: #f56c6c">{{
        this.orderData.total_amount
      }}</span>
                      </el-col>
                    </el-row>
                  </el-row>
                </el-form-item>
                <el-form-item label="快递单号" prop="exp_num">
                  <el-input v-model="editForm.exp_num" size="mini" placeholder="请输入快递单号" @input="getExp"></el-input>
                  <el-row v-if="expData" :gutter="0">
                    <el-row>
                      <el-col :span="24">
                        <span>快递单号：</span>
                        <span style="color: #409eff">{{ this.expData.exp_num }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>录入时间：</span>
                        <span>{{ this.expData.created_at }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>录入方式：</span>
                        <span style="color: #e6a23c">{{ this.expData.type }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>录入人：</span>
                        <span style="color: #67c23a">{{
        this.expData.exp_typeiner
      }}</span>
                      </el-col>
                    </el-row>
                  </el-row>
                </el-form-item>
                <el-form-item label="快递公司" prop="exp_company">
                  <el-select v-model="editForm.exp_company" placeholder="请选择快递公司" size="mini" style="width: 100%"
                    filterable clearable>
                    <el-option value="SFEXPRESS" label="顺丰"></el-option>
                    <el-option value="STO" label="申通"></el-option>
                    <el-option value="YTO" label="圆通"></el-option>
                    <el-option value="ZTO" label="中通"></el-option>
                    <el-option value="HTKY" label="汇通"></el-option>
                    <el-option value="YUNDA" label="韵达"></el-option>
                    <el-option value="TTKDEX" label="天天"></el-option>
                    <el-option value="JD" label="京东快递"></el-option>
                    <el-option value="ZJS" label="宅急送"></el-option>
                    <el-option value="CHINAPOST" label="EMS"></el-option>
                    <el-option value="INTMAIL" label="EMS国际"></el-option>
                    <el-option value="DEPPON" label="德邦"></el-option>
                    <el-option value="HTKY" label="百世快递"></el-option>
                    <el-option value="JITU" label="极兔速递"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="exp_phone" :inline-message="true">
                  <el-input v-model="editForm.exp_phone" size="mini" placeholder="请输入" maxlength="11" show-word-limit
                    clearable></el-input>
                </el-form-item>
                <el-form-item label="客户" prop="customer_name">
                  <el-input v-model="editForm.customer_name" size="mini" placeholder="选择公司自动添加" disabled></el-input>
                  <!-- @change="getCustomer" -->
                  <!-- <el-row v-if="customerData" :gutter="0">
              <el-row>
                <el-col :span="24">
                  <span>客户ID：</span>
                  <span style="color: #409eff">{{ this.customerData.id }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>客户昵称：</span>
                  <span style="color: #e6a23c">{{
                    this.customerData.name
                  }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>性别：</span>
                  <span style="color: #67c23a">{{
                    this.customerData.sex
                  }}</span>
                </el-col>
              </el-row>
            </el-row> -->
                </el-form-item>
                <el-form-item label="共享人" prop="share_id">
                  <el-cascader style="width: 100%" v-model="editForm.share_id" placeholder="请选择" :options="shareOptions"
                    size="mini" :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }" clearable
                    filterable @click.native="loadShare">
                  </el-cascader>
                  <!-- <el-select v-model="editForm.share_id" multiple placeholder="请选择" size="mini" @click.native="loadShare"
                    filterable style="width: 100%">
                    <el-option v-for="item in shareOptions" :key="item.id" :label="item.username" :value="item.id">
                    </el-option>
                  </el-select> -->
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <el-form-item label="上传截图/文件" prop="url">
            <el-upload action="https://weixin.qiyehuo.com/api/servicein/upfile" :headers="headers" multiple
              ref="uploadMutiple" :file-list="fileList" :limit="limit" :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess" :on-change="handleAvatarChange" :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove">
              <el-button size="mini" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip" style="color: #909399; margin-top: -0.1rem">
                单次上传最多10个文件或图片
              </div>
            </el-upload>
            <!-- <ul>
              <li v-for="item in fileNameList" :key="item" :title="item"><span class="notOver">{{item}}</span></li>
            </ul> -->
            <div style="margin-top: 0.2rem">
              <span><i class="el-icon-s-opportunity" style="color: #fb894c">点击下方，Ctrl+v上传</i></span>
            </div>
            <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
            <div id="preview" @paste="handlePaste"
              style="border: 3px dashed #409eff; border-radius: 15px; text-indent: 2em">
              <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
            </div>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm_edit('editForm')">修改</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer title="分配服务事项" :visible.sync="distributeDrawer" direction="rtl" :before-close="handleCloseDis"
      size="40%">
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form :model="distributeForm" :rules="rules_dis" ref="distributeForm" label-width="110px">
          <el-form-item label="公司名称" prop="company_id">
            <el-select v-model="distributeForm.company_id" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司"
              size="mini" clearable :remote-method="searchRemoteCompanyMethod" :loading="searchLoading"
              @change="getComUser" style="width: 100%" disabled>
              <el-option v-for="searchCompany in searchCompanies" :key="searchCompany.id"
                :label="searchCompany.company_name" :value="searchCompany.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成时间" prop="completed_at">
            <el-date-picker v-model="distributeForm.completed_at" type="datetimerange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="typeInPickerOptions"
              :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"
              size="mini" disabled>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="事项类型" prop="type">
            <el-checkbox v-model="distributeForm.type" size="mini" border disabled @change="clearNot">是否包含外勤
            </el-checkbox>
          </el-form-item>
          <el-form-item label="紧急程度" prop="urgent">
            <el-radio-group v-model="distributeForm.urgent" size="mini" disabled>
              <el-radio-button label="1">正常</el-radio-button>
              <el-radio-button label="2">紧急</el-radio-button>
              <el-radio-button label="3">非常紧急</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="难易程度" prop="easy">
            <el-radio-group v-model="distributeForm.easy" size="mini" disabled>
              <el-radio-button label="1">容易</el-radio-button>
              <el-radio-button label="2">正常</el-radio-button>
              <el-radio-button label="3">困难</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="事项分类" prop="categoryId">
            <el-select v-model="distributeForm.categoryId" placeholder="请选择" clearable filterable size="mini" disabled
              style="width: 100%" @click.native="loadCategory" @change="loadTitle">
              <el-option v-for="item in categoryIdOptions" :key="item.id" :label="item.category_name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事项内容" prop="title">
            <el-select v-model="distributeForm.title" placeholder="请选择" multiple clearable filterable size="mini"
              style="width: 100%" @change="changeTitle" disabled>
              <!-- @click.native="loadTitle" -->
              <el-option v-for="item in titleIdOptions" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内部可见" prop="detail_in">
            <el-input size="mini" type="textarea" v-model="distributeForm.detail_in" placeholder="内容详情"
              style="white-space: pre" disabled></el-input>
          </el-form-item>
          <el-form-item label="外部可见" prop="detail_out">
            <el-input size="mini" type="textarea" v-model="distributeForm.detail_out" placeholder="内容详情"
              style="white-space: pre" disabled></el-input>
          </el-form-item>
          <el-form-item label="事项备注" prop="remark">
            <el-input size="mini" type="textarea" v-model="distributeForm.remark" style="white-space: pre" disabled>
            </el-input>
          </el-form-item>
          <el-form-item label="办理人" prop="doner_id">
            <el-cascader style="width: 100%" v-model="distributeForm.doner_id" placeholder="请选择"
              :options="adminUserOptions" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
              filterable @click.native="loadAdminUser">
            </el-cascader>
            <!-- <el-select v-model="distributeForm.doner_id" placeholder="请选择" size="mini" @click.native="loadAdminUser"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="办理人(外勤)" prop="doner_id_w" v-if="distributeForm.type">
            <el-cascader style="width: 100%" v-model="distributeForm.doner_id_w" placeholder="请选择"
              :options="adminUserOptions_w" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
              filterable @click.native="loadAdminUserForW">
            </el-cascader>
            <!-- <el-select v-model="distributeForm.doner_id_w" placeholder="请选择" size="mini" @click.native="loadAdminUserForW"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions_w" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="办事地点" prop="address" v-if="distributeForm.type">
            <el-select clearable v-model="distributeForm.address" placeholder="请选择" size="mini"
              @click.native="loadPlace" filterable style="width: 100%">
              <el-option v-for="item in placeOptions" :key="item.id" :label="item.places_title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitDisForm('distributeForm')">分配</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="reSizeDialog" style="text-align: center" ref="reSize">
      <img ref="rotate" width="100%" :src="this.reSizeUrl" />
      <!-- <el-button type="primary" size="mini" @click="rotate">旋转</el-button> -->
    </el-dialog>

    <div class="middle-table">
      <el-table :data="serviceInData" height="calc(100vh - 306px)" style="width: 100%;" border size="mini"
        :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }">
        <el-table-column prop="company.company_name" label="公司名称" width="280" fixed>
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.company.company_name" placement="top"
              style="display: inline-block">
              <el-link style="
                display: block;
                color: #409eff;
                font-size: 0.28rem;
                cursor: pointer;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              " @click="openCompanyCom(scope.row)">
                {{ scope.row.company.company_name }}
              </el-link>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="复制" placement="top"><i class="el-icon-document-copy"
                style="margin-left: 0.1rem; cursor: pointer"
                @click="copySome(scope.row.company.company_name)"></i></el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="typeiner.username" label="创建人" width="140">
          <template slot-scope="scope">
            <p>{{ scope.row.typeiner.username }}</p>
            <p>
              <!-- {{ scope.row.created_at }} -->
              <date-formatter :date-value="scope.row.created_at"></date-formatter>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="completed_at" label="ETA处理时间" width="250">
          <template slot-scope="scope">
            <date-formatter :date-value="scope.row.completed_at_start"></date-formatter>
            &nbsp;至&nbsp;
            <date-formatter :date-value="scope.row.completed_at_end"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column prop="donner.username" label="办理人" width="120">
          <template slot-scope="scope">
            <div v-if="!scope.row.overTime">
              <span v-if="!scope.row.donner">
                <span>
                  <el-tooltip class="item" effect="dark" content="点击添加办理人" placement="top">
                    <el-popover placement="left-start" width="300" trigger="click">
                      <el-form :model="addAddressForm" :rules="addressRules" ref="addAddressForm" label-width="80px"
                        style="padding-right: 0.33rem">
                        <el-form-item label="办理人" prop="doner_id">
                          <el-cascader style="width: 100%" v-model="addAddressForm.doner_id" placeholder="请选择"
                            :options="adminUserOptions_a" size="mini"
                            :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                            @click.native="loadAdminUser_a">
                          </el-cascader>
                          <!-- <el-select v-model="addAddressForm.doner_id" placeholder="请选择" size="mini"
                          @click.native="loadAdminUser_a" filterable style="width: 100%" clearable>
                          <el-option v-for="item in adminUserOptions_a" :key="item.id" :label="item.username"
                            :value="item.id">
                          </el-option>
                        </el-select> -->
                        </el-form-item>
                      </el-form>
                      <div style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.33rem;
                      ">
                        <el-button type="primary" size="mini" @click="saveChange('addAddressForm', scope.row.id)">保存
                        </el-button>
                      </div>
                      <i slot="reference" style="cursor: pointer; font-size: 0.38rem; color: #409eff"
                        class="el-icon-circle-plus-outline"></i>
                    </el-popover>
                  </el-tooltip>
                </span>
              </span>
              <span v-else>
                <span>
                  {{ scope.row.donner.username }}
                </span>
              </span>
            </div>
            <div v-if="scope.row.overTime">
              <span v-if="!scope.row.donner">
                <span>
                  <el-tooltip class="item" effect="dark" content="点击添加办理人" placement="top">
                    <el-popover placement="left-start" width="300" trigger="click">
                      <el-form :model="addAddressForm" :rules="addressRules" ref="addAddressForm" label-width="80px"
                        style="padding-right: 0.33rem">
                        <el-form-item label="办理人" prop="doner_id">
                          <el-cascader style="width: 100%" v-model="addAddressForm.doner_id" placeholder="请选择"
                            :options="adminUserOptions_a" size="mini"
                            :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                            @click.native="loadAdminUser_a">
                          </el-cascader>
                          <!-- <el-select v-model="addAddressForm.doner_id" placeholder="请选择" size="mini"
                          @click.native="loadAdminUser_a" filterable style="width: 100%" clearable>
                          <el-option v-for="item in adminUserOptions_a" :key="item.id" :label="item.username"
                            :value="item.id">
                          </el-option>
                        </el-select> -->
                        </el-form-item>
                      </el-form>
                      <div style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.33rem;
                      ">
                        <el-button type="primary" size="mini" @click="saveChange('addAddressForm', scope.row.id)">保存
                        </el-button>
                      </div>
                      <i slot="reference" style="cursor: pointer; font-size: 0.38rem; color: #409eff"
                        class="el-icon-circle-plus-outline"></i>
                    </el-popover>
                  </el-tooltip>
                </span>
                <span>
                  <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                    <i class="el-icon-warning" style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"></i>
                  </el-tooltip>
                </span>
              </span>
              <span v-else>
                <span>
                  {{ scope.row.donner.username }}
                </span>
                <span>
                  <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                    <i class="el-icon-warning" style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"></i>
                  </el-tooltip>
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="donner_w.username" label="外勤办理人" width="120">
          <template slot-scope="scope">
            <div v-if="!scope.row.overTime">
              <span v-if="!scope.row.donner_w && scope.row.type === 'w'">
                <span>
                  <el-tooltip class="item" effect="dark" content="点击添加办理人(外勤)" placement="top">
                    <el-popover placement="left-start" width="300" trigger="click">
                      <el-form :model="addAddressFormW" :rules="addressRules" ref="addAddressFormW" label-width="100px"
                        style="padding-right: 0.31rem">
                        <el-form-item label="办理人(外勤)" prop="doner_id_w">
                          <el-cascader style="width: 100%" v-model="addAddressFormW.doner_id_w" placeholder="请选择"
                            :options="adminUserOptions_a_w" size="mini"
                            :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                            @click.native="loadAdminUser_a_w">
                          </el-cascader>
                          <!-- <el-select v-model="addAddressFormW.doner_id_w" placeholder="请选择" size="mini"
                          @click.native="loadAdminUser_a_w" filterable style="width: 100%" clearable>
                          <el-option v-for="item in adminUserOptions_a_w" :key="item.id" :label="item.username"
                            :value="item.id">
                          </el-option>
                        </el-select> -->
                        </el-form-item>
                      </el-form>
                      <div style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.31rem;
                      ">
                        <el-button type="primary" size="mini" @click="saveChange_aw('addAddressFormW', scope.row.id)">保存
                        </el-button>
                      </div>
                      <i slot="reference" style="cursor: pointer; font-size: 0.38rem; color: #409eff"
                        class="el-icon-circle-plus-outline"></i>
                    </el-popover>
                  </el-tooltip>
                </span>
              </span>
              <span v-if="scope.row.donner_w">{{ scope.row.donner_w.username }}</span>
            </div>
            <div v-if="scope.row.overTime">
              <span v-if="!scope.row.donner_w && scope.row.type === 'w'">
                <span>
                  <el-tooltip class="item" effect="dark" content="点击添加办理人(外勤)" placement="top">
                    <el-popover placement="left-start" width="300" trigger="click">
                      <el-form :model="addAddressFormW" :rules="addressRules" ref="addAddressFormW" label-width="100px"
                        style="padding-right: 0.31rem">
                        <el-form-item label="办理人(外勤)" prop="doner_id_w">
                          <el-cascader style="width: 100%" v-model="addAddressFormW.doner_id_w" placeholder="请选择"
                            :options="adminUserOptions_a_w" size="mini"
                            :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                            @click.native="loadAdminUser_a_w">
                          </el-cascader>
                          <!-- <el-select v-model="addAddressFormW.doner_id_w" placeholder="请选择" size="mini"
                          @click.native="loadAdminUser_a_w" filterable style="width: 100%" clearable>
                          <el-option v-for="item in adminUserOptions_a_w" :key="item.id" :label="item.username"
                            :value="item.id">
                          </el-option>
                        </el-select> -->
                        </el-form-item>
                      </el-form>
                      <div style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.31rem;
                      ">
                        <el-button type="primary" size="mini" @click="saveChange_aw('addAddressFormW', scope.row.id)">保存
                        </el-button>
                      </div>
                      <i slot="reference" style="cursor: pointer; font-size: 0.38rem; color: #409eff"
                        class="el-icon-circle-plus-outline"></i>
                    </el-popover>
                  </el-tooltip>
                </span>
                <span>
                  <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                    <i class="el-icon-warning" style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"></i>
                  </el-tooltip>
                </span>
              </span>
              <span v-if="scope.row.donner_w">
                <span>{{ scope.row.donner_w.username }}</span>
                <span>
                  <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                    <i class="el-icon-warning" style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"></i>
                  </el-tooltip>
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="urge_count" label="催办次数" width="120">
          <template slot-scope="scope">
            <div style="padding: 0.28rem 0" v-if="scope.row.urge_count > 0">
              <el-badge :value="scope.row.urge_count" class="item">
                <el-button size="mini" @click="openUrgeCount(scope.row.urges)">催办次数</el-button>
              </el-badge>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="feed_count" label="反馈次数" width="80"> </el-table-column>
        <el-table-column prop="feed[0].created_at" label="最后一次反馈时间" width="160">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="点击查看" placement="top" v-if="scope.row.feed.length > 0">
              <el-popover placement="right" width="300" trigger="click">
                <el-row type="flex" class="row-bg" justify="center">
                  <el-col :span="10">反馈人:</el-col>
                  <el-col :span="14" style="font-weight: normal">
                    {{ scope.row.feed[0].feedbacker }}
                  </el-col>
                </el-row>
                <el-row type="flex" class="row-bg" justify="center">
                  <el-col :span="10">反馈内容:</el-col>
                  <el-col :span="14" style="font-weight: normal">
                    {{ scope.row.feed[0].feedback }}
                  </el-col>
                </el-row>
                <el-row type="flex" class="row-bg" justify="center">
                  <el-col :span="10">预计完成时间:</el-col>
                  <el-col :span="14" style="font-weight: normal">
                    <!-- {{ scope.row.feed[0].es_time }} -->
                    <date-formatter :date-value="scope.row.feed[0].es_time"></date-formatter>
                  </el-col>
                </el-row>
                <i slot="reference" style="cursor: pointer; font-size: 0.28rem; color: #409eff">
                  <!-- {{ scope.row.feed[0].created_at }} -->
                  <date-formatter :date-value="scope.row.feed[0].created_at"></date-formatter>
                </i>
              </el-popover>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="type_name" label="服务类型" width="100"> </el-table-column>
        <el-table-column prop="order_num" label="订单号" width="190">
          <template slot-scope="scope">
            <span v-if="scope.row.order_num">
              <el-link style="color: #409eff"
                @click="handleOrderInfo(scope.row.orderId, scope.row.company.company_name)">{{ scope.row.order_num
                }}</el-link>
            </span>
            <span style="color: #f56c6c" v-else>
              <el-tooltip class="item" effect="dark" content="点击绑定订单" placement="top">
                <el-popover @hide="clearSelf" placement="bottom" width="300" trigger="click">
                  <el-input v-model="table_OrderData" size="mini" placeholder="输入订单号绑定订单"></el-input>
                  <div style="margin-top: 0.15rem; text-align: right">
                    <el-button type="primary" size="mini" @click="bindOrderNum(scope.row.id)">保存</el-button>
                  </div>
                  <span slot="reference" style="cursor: pointer; color: #f56c6c">无订单号</span>
                </el-popover>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="title_name" label="事项" width="230"> </el-table-column>
        <el-table-column prop="diser.username" label="分配人" width="140">
          <template slot-scope="scope">
            <p v-if="scope.row.diser">{{ scope.row.diser.username }}</p>
            <p>
              <!-- {{ scope.row.distribute_at }} -->
              <date-formatter :date-value="scope.row.distribute_at"></date-formatter>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="progress" label="进度" width="150">
          <template slot-scope="scope">
            <div v-if="!scope.row.overTimeD">
              <p>{{ scope.row.progress }}</p>
              <p v-if="scope.row.progress === '已完成'">
                {{ scope.row.done_at }}
              </p>
              <p v-if="scope.row.screen.length > 0">
                <el-link style="color: #409eff" @click.native="openImageDrawer(scope.row.screen)"><span>相关截图/文件</span>
                </el-link>
              </p>
            </div>
            <div v-if="scope.row.overTimeD">
              <p>
                <span>{{ scope.row.progress }}</span>
                <span>
                  <el-tooltip class="item" effect="dark" content="办理超时" placement="top">
                    <i class="el-icon-warning" style="font-size: 0.35rem; color: #f56c6c; margin-left: 0.25rem"></i>
                  </el-tooltip>
                </span>
              </p>
              <p v-if="scope.row.progress === '已完成'">
                {{ scope.row.done_at }}
              </p>
              <p v-if="scope.row.screen.length > 0">
                <el-link @click.native="openImageDrawer(scope.row.screen)" style="color: #409eff">相关截图/文件</el-link>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <el-button @click.native.prevent="openEdit(scope.row)" type="primary" size="mini" icon="el-icon-edit"
                circle>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="分配" placement="top">
              <el-button @click.native.prevent="openDistribute(scope.row)" type="success" size="mini"
                icon="el-icon-user" circle>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="" placement="top">
              <template slot="content">
                <p>催办</p>
                <p>催办时间间隔为24h</p>
              </template>
              <el-button @click.native.prevent="openUrge(scope.row)" type="danger" size="mini"
                icon="el-icon-message-solid" circle :disabled="(scope.row.urge.length > 0 ? scope.row.urge[0].notTime : false) ||
        scope.row.progress === '已完成'
        ">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="企业微信群聊天记录" placement="top">
              <el-button type="warning" @click="
        handleWxChatOpen(
          scope.row.wx_work_chat_com,
          scope.row.company.company_name
        )
        " size="mini" icon="el-icon-s-comment" circle :disabled="scope.row.wx_work_chat_com ? false : true">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-phone-outline" circle
                @click="handCallLogsOpen(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page-footer">
      <el-pagination class="pagination-style" @current-change="handleCurrentChange" @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper" :total="total" :current-page.sync="nowPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="valuePerPage" background>
      </el-pagination>
    </div>
    <el-drawer direction="rtl" :visible.sync="urgeCountDrawer" :before-close="handUrgeCountDrawerClose" size="40%">
      <template slot="title">
        <span style="font-size: 0.3rem; font-weight: 700; color: #409eff">催办记录</span>
      </template>
      <div style="padding: 0 0.2rem">
        <el-timeline>
          <el-timeline-item class="logistics" v-for="(item, index) in urgeCountData" :key="index"
            :timestamp="item.created_at">
            <div v-if="item.type === 1">
              <p>
                <span>
                  <span style="color: #409eff; font-size: 0.2rem">(内部)</span>{{ item.urge_name }}</span>
                <span>在</span>
                <span>{{ item.created_at }}</span>
                <span>催办</span>
              </p>
              <p v-if="item.confirm === 0" style="margin-top: 0.28rem">
                <el-button type="primary" size="mini" @click="confirmUrge(item.id, index)">确认</el-button>
              </p>
              <p v-if="item.confirm === 1" style="margin-top: 0.28rem">
                <span style="font-size: 0.3rem; color: #67c23a">已确认</span>
                <span style="margin-left: 0.2rem">{{ item.confirm_name }}</span>
                <span>{{ item.confirmed_at }}</span>
              </p>
            </div>
            <div v-if="item.type === 2">
              <p>
                <span><span style="color: #e6a23c; font-size: 0.2rem">(客户)</span>{{ item.urge_name }}</span>
                <span>在</span>
                <span>{{ item.created_at }}</span>
                <span>催办</span>
              </p>
              <p v-if="item.confirm === 0" style="margin-top: 0.28rem">
                <el-button type="primary" size="mini" @click="confirmUrge(item.id, index)">确认</el-button>
              </p>
              <p v-if="item.confirm === 1" style="margin-top: 0.28rem">
                <span style="font-size: 0.3rem; color: #67c23a">已确认</span>
                <span style="margin-left: 0.2rem">{{ item.confirm_name }}</span>
                <span>{{ item.confirmed_at }}</span>
              </p>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
    <el-drawer :visible.sync="serviceInDrawer" direction="rtl" :before-close="handleClose" size="40%">
      <template slot="title">
        <span style="font-size: 0.38rem; font-weight: 700; color: #409eff">服务事项录入</span>
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form :model="serviceInForm" :rules="rules" ref="serviceInForm" label-width="100px">
          <el-form-item label="公司名称" prop="company_id">
            <el-select v-model="serviceInForm.company_id" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司"
              size="mini" clearable :disabled="drawerTitle === '修改'" :remote-method="searchRemoteCompanyMethod"
              :loading="searchLoading" @change="getComUser" style="width: 100%">
              <el-option v-for="searchCompany in searchCompanies" :key="searchCompany.id"
                :label="searchCompany.company_name" :value="searchCompany.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成时间" prop="completed_at">
            <el-date-picker v-model="serviceInForm.completed_at" type="datetimerange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="typeInPickerOptions"
              :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"
              size="mini">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="事项类型" prop="type">
            <el-checkbox v-model="serviceInForm.type" size="mini" label="w" border @change="clearNot">是否包含外勤
            </el-checkbox>
          </el-form-item>
          <el-form-item label="紧急程度" prop="urgent">
            <el-radio-group v-model="serviceInForm.urgent" size="mini">
              <el-radio-button label="1">正常</el-radio-button>
              <el-radio-button label="2">紧急</el-radio-button>
              <el-radio-button label="3">非常紧急</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="难易程度" prop="easy">
            <el-radio-group v-model="serviceInForm.easy" size="mini">
              <el-radio-button label="1">容易</el-radio-button>
              <el-radio-button label="2">正常</el-radio-button>
              <el-radio-button label="3">困难</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="事项分类" prop="categoryId">
            <el-select v-model="serviceInForm.categoryId" placeholder="请选择" clearable filterable size="mini"
              style="width: 100%" @click.native="loadCategory" @change="loadTitle">
              <el-option v-for="item in categoryIdOptions" :key="item.id" :label="item.category_name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事项内容" prop="title">
            <el-select v-model="serviceInForm.title" placeholder="请选择" multiple clearable filterable size="mini"
              style="width: 100%" @change="changeTitle">
              <!-- @click.native="loadTitle" -->
              <el-option v-for="item in titleIdOptions" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内部可见" prop="detail_in">
            <el-input size="mini" type="textarea" v-model="serviceInForm.detail_in" placeholder="内容详情"
              style="white-space: pre"></el-input>
          </el-form-item>
          <el-form-item label="外部可见" prop="detail_out">
            <el-input size="mini" type="textarea" v-model="serviceInForm.detail_out" placeholder="内容详情"
              style="white-space: pre"></el-input>
          </el-form-item>
          <el-form-item label="是否分配" prop="is_dis">
            <el-checkbox v-model="serviceInForm.is_dis" size="mini" label="now" border @change="doSomeThing">现在分配
            </el-checkbox>
          </el-form-item>
          <el-form-item label="办理人" prop="doner_id" v-if="serviceInForm.is_dis && !serviceInForm.type">
            <el-cascader style="width: 100%" v-model="serviceInForm.doner_id" placeholder="请选择"
              :options="adminUserOptions" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
              filterable @click.native="loadAdminUser">
            </el-cascader>
            <!-- <el-select v-model="serviceInForm.doner_id" placeholder="请选择" size="mini" @click.native="loadAdminUser"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="办理人" prop="doner_id_n" v-if="serviceInForm.is_dis && serviceInForm.type">
            <el-cascader style="width: 100%" v-model="serviceInForm.doner_id_n" placeholder="请选择"
              :options="adminUserOptions" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
              filterable @click.native="loadAdminUser">
            </el-cascader>
            <!-- <el-select v-model="serviceInForm.doner_id_n" placeholder="请选择" size="mini" @click.native="loadAdminUser"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="外勤办理人" prop="doner_id_w" v-if="serviceInForm.type && serviceInForm.is_dis">
            <el-cascader style="width: 100%" v-model="serviceInForm.doner_id_w" placeholder="请选择"
              :options="adminUserOptions_w" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
              filterable @click.native="loadAdminUserForW">
            </el-cascader>
            <!-- <el-select v-model="serviceInForm.doner_id_w" placeholder="请选择" size="mini" @click.native="loadAdminUserForW"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in adminUserOptions_w" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="办事地点" prop="address" v-if="serviceInForm.type && serviceInForm.is_dis">
            <el-select v-model="serviceInForm.address" placeholder="请选择" size="mini" @click.native="loadPlace"
              filterable style="width: 100%" clearable>
              <el-option v-for="item in placeOptions" :key="item.id" :label="item.places_title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事项备注" prop="remark">
            <el-input size="mini" type="textarea" v-model="serviceInForm.remark" placeholder="内容详情"></el-input>
          </el-form-item>
          <el-form-item label="补充信息">
            <el-collapse v-model="activeNames_in">
              <el-collapse-item title="" name="1">
                <template slot="title">
                  <span style="color: #409eff">点击打开/隐藏</span>
                </template>
                <el-form-item label="订单号" prop="order_num">
                  <el-input v-model="serviceInForm.order_num" size="mini" placeholder="请输入订单号" @input="getOrder">
                  </el-input>
                  <el-row v-if="orderData" :gutter="0">
                    <el-row>
                      <el-col>
                        <span>订单号：</span>
                        <span style="color: #409eff">{{ this.orderData.order_num }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>创建时间：</span>
                        <span>{{ this.orderData.created_at }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>订单类型：</span>
                        <span style="color: #e6a23c">{{
        this.orderData.order_type
      }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>转化人：</span>
                        <span style="color: #67c23a">{{
        this.orderData.convert_name
      }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>订单总金额：</span>
                        <span style="color: #f56c6c">{{
        this.orderData.total_amount
      }}</span>
                      </el-col>
                    </el-row>
                  </el-row>
                </el-form-item>
                <el-form-item label="快递单号" prop="exp_num">
                  <el-input v-model="serviceInForm.exp_num" size="mini" placeholder="请输入快递单号" @input="getExp">
                  </el-input>
                  <el-row v-if="expData" :gutter="0">
                    <el-row>
                      <el-col :span="24">
                        <span>快递单号：</span>
                        <span style="color: #409eff">{{ this.expData.exp_num }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>录入时间：</span>
                        <span>{{ this.expData.created_at }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>录入方式：</span>
                        <span style="color: #e6a23c">{{ this.expData.type }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <span>录入人：</span>
                        <span style="color: #67c23a">{{
        this.expData.exp_typeiner
      }}</span>
                      </el-col>
                    </el-row>
                  </el-row>
                </el-form-item>
                <el-form-item label="快递公司" prop="exp_company">
                  <el-select v-model="serviceInForm.exp_company" placeholder="请选择快递公司" size="mini" style="width: 100%"
                    filterable clearable>
                    <el-option value="SFEXPRESS" label="顺丰"></el-option>
                    <el-option value="STO" label="申通"></el-option>
                    <el-option value="YTO" label="圆通"></el-option>
                    <el-option value="ZTO" label="中通"></el-option>
                    <el-option value="HTKY" label="汇通"></el-option>
                    <el-option value="YUNDA" label="韵达"></el-option>
                    <el-option value="TTKDEX" label="天天"></el-option>
                    <el-option value="JD" label="京东快递"></el-option>
                    <el-option value="ZJS" label="宅急送"></el-option>
                    <el-option value="CHINAPOST" label="EMS"></el-option>
                    <el-option value="INTMAIL" label="EMS国际"></el-option>
                    <el-option value="DEPPON" label="德邦"></el-option>
                    <el-option value="HTKY" label="百世快递"></el-option>
                    <el-option value="JITU" label="极兔速递"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="exp_phone" :inline-message="true">
                  <el-input v-model="serviceInForm.exp_phone" size="mini" placeholder="请输入" maxlength="11"
                    show-word-limit clearable></el-input>
                </el-form-item>
                <el-form-item label="客户" prop="customer_name">
                  <el-input v-model="serviceInForm.customer_name" size="mini" placeholder="选择公司自动添加" disabled>
                  </el-input>
                  <!-- @input="getCustomer" -->
                  <!-- <el-row v-if="customerData" :gutter="0">
              <el-row>
                <el-col :span="24">
                  <span>客户ID：</span>
                  <span style="color: #409eff">{{ this.customerData.id }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>客户昵称：</span>
                  <span style="color: #e6a23c">{{
                    this.customerData.name
                  }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>性别：</span>
                  <span style="color: #67c23a">{{
                    this.customerData.sex
                  }}</span>
                </el-col>
              </el-row>
            </el-row> -->
                </el-form-item>
                <el-form-item label="共享人" prop="share_id">
                  <el-cascader style="width: 100%" v-model="serviceInForm.share_id" placeholder="请选择"
                    :options="shareOptions" size="mini"
                    :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }" clearable filterable
                    @click.native="loadShare">
                  </el-cascader>
                  <!-- <el-select v-model="serviceInForm.share_id" multiple placeholder="请选择" size="mini"
                    @click.native="loadShare" filterable style="width: 100%">
                    <el-option v-for="item in shareOptions" :key="item.id" :label="item.username" :value="item.id">
                    </el-option>
                  </el-select> -->
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
          <el-form-item label="上传截图/文件" prop="url">
            <el-upload action="https://weixin.qiyehuo.com/api/servicein/upfile" :headers="headers" multiple
              ref="uploadMutiple" :file-list="fileList" :limit="limit" :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess" :on-change="handleAvatarChange" :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove">
              <el-button size="mini" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip" style="color: #909399; margin-top: -0.1rem">
                单次上传最多10个文件或图片
              </div>
            </el-upload>
            <!-- <ul>
              <li v-for="item in fileNameList" :key="item" :title="item"><span class="notOver">{{item}}</span></li>
            </ul> -->
            <div style="margin-top: 0.2rem">
              <span><i class="el-icon-s-opportunity" style="color: #fb894c">点击下方，Ctrl+v上传</i></span>
            </div>
            <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
            <div id="preview" @paste="handlePaste"
              style="border: 3px dashed #409eff; border-radius: 15px; text-indent: 2em">
              <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
            </div>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm('serviceInForm')">添加</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import CallLogs from "common/CallLogs";
import WxWorkChat from "common/WxWorkChat";
import CompanyInfo from "common/CompanyInfo";
import OrderInfo from "common/OrderInfo";
import Vue from "vue";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import DateFormatter from 'common/DateFormatter'

export default {
  name: "ServiceIn",
  mixins: [fscDate],
  components: { CompanyInfo, CallLogs, WxWorkChat, OrderInfo, DateFormatter },
  data() {
    Vue.directive("down", {
      inserted: (el, binding) => {
        el.style.cssText = "cursor: pointer;color:write;";
        el.addEventListener("click", () => {
          // console.log(binding.value)
          let link = document.createElement("a");
          let image = document.createElement("image");
          let url = binding.value;
          let downloadName = url.slice(url.lastIndexOf("/") + 1);
          // console.log(downloadName);
          // 这里是将url转成blob地址，
          image.setAttribute("crossOrigin", "anonymous"); // 这句可以解决跨域问题
          fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              link.href = URL.createObjectURL(blob);
              // console.log(link.href)
              link.download = downloadName;
              document.body.appendChild(link);
              link.click();
            });
        });
      },
    });
    // var checkPhone = (rule, value, callback) => {
    //   if (value !== '') {
    //     var reg = /^1[3456789]\d{9}$/
    //     if (!reg.test(value)) {
    //       callback(new Error('请输⼊有效的⼿机号码'))
    //     }
    //   }
    //   callback()
    // }
    return {
      hyperfHost:
        process.env.NODE_ENV === "development"
          ? "http://127.0.0.1:9501"
          : "https://qyh-next-server.zhang66.cn",
      urgeCountData: [],
      pendCheckType: this.$feedBackConfig.pending_matter,
      urgeCountDrawer: false,
      cTime: 0,
      cTimeD: 0,
      reSizeUrl: "",
      reSizeDialog: false,
      deg: 0,
      imageData: [],
      imageDrawer: false,
      table_OrderData: null,
      orderInfoId: null,
      orderInfoVisible: false,
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      company: null,
      wxWorkChatId: null,
      wxWorkchatCompany: null,
      wxChatDrawer: false,
      callLogsDrawer: false,
      adminUserOptions_a_w: [],
      addAddressFormW: {
        doner_id_w: "",
      },
      addressRules: {},
      adminUserOptions_a: [],
      addAddressForm: {
        doner_id: "",
      },
      activeNames_in_edit: [],
      activeNames_in: [],
      watchDetail_in_arr_edit: [],
      idForEdit: null,
      change: false,
      drawerTitle: "",
      sharerOptions: [],
      activeNames: [""],
      adminUserOptions_w: [],
      serviceInDrawer: false,
      searchLoading: false,
      companyInfoDrawer: false,
      editDrawer: false,
      distributeDrawer: false,
      businessOptionsC: [],
      kefuOptionsC: [],
      jizhangOptionsC: [],
      taxOptionsC: [],
      kaipiaoOptionsC: [],
      leaderOptionsC: [],
      searchForm: {
        type: "",
        done_at: "",
        companyId: "",
        typeiner_id: "",
        doner_id: "",
        doner_id_w: "",
        dis_id: "",
        progress: "",
        status: "",
        handle_at: "",
        created_at: "",
        category_id: "",
        schedule_id: "",
        share_id: "",
        businessC: "",
        kefuC: "",
        jizhangC: "",
        taxC: "",
        kaipiaoC: "",
        leaderC: "",
      },
      distributeForm: {
        id: "",
        company_id: "",
        completed_at: "",
        type: "",
        urgent: "",
        easy: "",
        categoryId: "",
        title: "",
        detail_in: "",
        detail_out: "",
        handle_at: "",
        doner_id: "",
        address: "",
        remark: "",
        doner_id_w: "",
      },
      serviceInForm: {
        doner_id_n: "",
        exp_company: "",
        exp_phone: "",
        is_dis: "",
        company_id: "",
        order_num: "",
        completed_at: "",
        type: "",
        categoryId: "",
        title: [],
        detail_in: "",
        detail_out: "",
        cate: {},
        title_name: "",
        share_id: [],
        exp_num: "",
        customer_id: "",
        customer_name: "",
        urgent: "",
        easy: "",
        doner_id: "",
        address: "",
        remark: "",
        doner_id_w: "",
      },
      editForm: {
        exp_company: "",
        exp_phone: "",
        is_dis: "",
        company_id: "",
        order_num: "",
        completed_at: "",
        type: "",
        categoryId: "",
        title: [],
        detail_in: "",
        detail_out: "",
        cate: {},
        title_name: "",
        share_id: "",
        exp_num: "",
        customer_id: "",
        customer_name: "",
        urgent: "",
        easy: "",
        doner_id: "",
        address: "",
        remark: "",
        doner_id_w: "",
      },
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      limit: 10,
      orderData: "",
      judgeType: "",
      companyComId: null,
      total: 0,
      npage: 1,
      nowPage: 1,
      valuePerPage: 30,
      needUrl: [],
      category_idOptions: [],
      schedule_idOptions: [],
      fileNameList: [],
      header: [],
      expData: null,
      fileList: [],
      shareOptions: [],
      customerData: null,
      typeinerOptions: [],
      donerOptions: [],
      diserOptions: [],
      searchCompaniesx: [],
      searchCompanies: [],
      categoryIdOptions: [],
      titleIdOptions: [],
      watchDetail_in_arr: [],
      serviceInData: [],
      adminUserOptions: [],
      placeOptions: [],
      rules: {
        // exp_phone: [
        //   {
        //     validator: checkPhone,
        //     trigger: 'blur'
        //   }
        // ],
        company_id: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        completed_at: [{ required: true, message: "请输入完成时间", trigger: "blur" }],
        categoryId: [{ required: true, message: "请选择事项分类", trigger: "blur" }],
        title: [{ required: true, message: "请选择事项内容", trigger: "blur" }],
        detail_in: [{ max: 2000, message: "长度最多2000个字符", trigger: "blur" }],
        detail_out: [{ max: 2000, message: "长度最多2000个字符", trigger: "blur" }],
        order_num: [{ max: 255, message: "长度最多255个字符", trigger: "blur" }],
        doner_id: [{ required: true, message: "请选择办理人", trigger: "blur" }],
        doner_id_w: [{ required: true, message: "请选择办理人(外勤)", trigger: "blur" }],
        address: [{ required: true, message: "请选择办事地点", trigger: "blur" }],
      },
      rules_dis: {
        // exp_phone: [
        //   {
        //     validator: checkPhone,
        //     trigger: 'blur'
        //   }
        // ],
        company_id: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        completed_at: [{ required: true, message: "请输入完成时间", trigger: "blur" }],
        categoryId: [{ required: true, message: "请选择事项分类", trigger: "blur" }],
        title: [{ required: true, message: "请选择事项内容", trigger: "blur" }],
        detail_in: [{ max: 2000, message: "长度最多2000个字符", trigger: "blur" }],
        detail_out: [{ max: 2000, message: "长度最多2000个字符", trigger: "blur" }],
        order_num: [{ max: 255, message: "长度最多255个字符", trigger: "blur" }],
        // doner_id: [
        //   { required: true, message: '请选择办理人', trigger: 'blur' }
        // ],
        doner_id_w: [{ required: true, message: "请选择办理人(外勤)", trigger: "blur" }],
        address: [{ required: true, message: "请选择办事地点", trigger: "blur" }],
      },
      rules_edit: {
        // exp_phone: [
        //   {
        //     validator: checkPhone,
        //     trigger: 'blur'
        //   }
        // ],
        company_id: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        completed_at: [{ required: true, message: "请输入完成时间", trigger: "blur" }],
        categoryId: [{ required: true, message: "请选择事项分类", trigger: "blur" }],
        title: [{ required: true, message: "请选择事项内容", trigger: "blur" }],
        detail_in: [{ max: 2000, message: "长度最多2000个字符", trigger: "blur" }],
        detail_out: [{ max: 2000, message: "长度最多2000个字符", trigger: "blur" }],
        order_num: [{ max: 255, message: "长度最多255个字符", trigger: "blur" }],
        // doner_id: [
        //   { required: true, message: '请选择办理人', trigger: 'blur' }
        // ],
        // doner_id_w: [
        //   { required: true, message: '请选择办理人(外勤)', trigger: 'blur' }
        // ],
        // address: [
        //   { required: true, message: '请选择办事地点', trigger: 'blur' }
        // ]
      },
      typeInPickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
      },
      pickerOptionsDis: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
      },
      searchPickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.deg = 0;
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    confirmUrge(id, index) {
      this.$axios
        .put("api/servicein/urgeconfirm?id=" + id, {
          // order_num: this.table_OrderData
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            // var myEvent = new Event('click')
            // document.dispatchEvent(myEvent)
            this.$message.success(data.msg);
            // this.table_OrderData = null
            this.urgeCountData[index].confirm = 1;
            this.urgeCountData[index].confirmed_at = new Date().toLocaleString();
            this.urgeCountData[index].confirm_name = data.data.confirm_name;
            this.loadTable();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    openUrgeCount(data) {
      this.urgeCountData = data;
      this.urgeCountData.reverse();
      this.urgeCountDrawer = true;
    },
    handUrgeCountDrawerClose(done) {
      this.urgeCountData = [];
      done();
    },
    openUrge(row) {
      this.$axios
        .put("api/servicein/urge?id=" + row.id, {
          // order_num: this.table_OrderData
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            // var myEvent = new Event('click')
            // document.dispatchEvent(myEvent)
            this.$message.success(data.msg);
            // this.table_OrderData = null
            this.loadTable();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    reSizePic(url) {
      this.reSizeUrl = url;
      this.reSizeDialog = true;
    },
    // 旋转图片
    rotate() {
      this.deg += 90;
      if (this.deg >= 360) {
        this.deg = 0;
      }
      if (this.deg === 90) {
        this.$refs.reSize.style.width = "100%";
      }
      this.$refs.rotate.style.transform = `rotate(${this.deg}deg)`;
    },
    openImageDrawer(screen) {
      this.imageData = screen;
      this.imageDrawer = true;
    },
    progressClear(val) {
      if (val !== "y") {
        this.searchForm.done_at = "";
      }
    },
    clearSelf() {
      this.table_OrderData = null;
    },
    bindOrderNum(id) {
      if (this.table_OrderData) {
        this.$axios
          .put("api/sfeedback/singleaddordernum?id=" + id, {
            order_num: this.table_OrderData,
          })
          .then((res) => {
            const { data } = res;
            if (data.code === 1) {
              var myEvent = new Event("click");
              document.dispatchEvent(myEvent);
              this.$message.success(data.msg);
              this.table_OrderData = null;
              this.loadTable();
            } else {
              this.$message.error(data.msg);
            }
          });
      }
    },
    handleOrderInfo(orderId, companyName) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
      });
    },
    changeOrder(id, contactTime) {
      for (var i = 0; i < this.pageData.length; i++) {
        if (this.pageData[i].id === id) {
          this.pageData[i].contact_time = contactTime;
        }
      }
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    loadAdminLeaderC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.leaderOptionsC = data.data;
        }
      });
    },
    loadAdminKaipiaoC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.kaipiaoOptionsC = data.data;
        }
      });
    },
    loadAdminTaxC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.taxOptionsC = data.data;
        }
      });
    },
    loadAdminJizhangC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.jizhangOptionsC = data.data;
        }
      });
    },
    loadAdminKefuC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.kefuOptionsC = data.data;
        }
      });
    },
    loadAdminUserNew() {
      // return this.$axios.get('api/expmanage/getreceiver')
      return this.$axios.get("api/admin/user/branch");
    },
    loadAdminBusC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.businessOptionsC = data.data;
        }
      });
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company.company_name;
        if (row.user) this.callPhone.push(row.user.phone);
        if (row.company.docking_phone) {
          this.callPhone3.push(row.company.docking_phone);
        }
        if (row.tyc_orders.length > 0) {
          for (var i = 0; i < row.tyc_orders.length; i++) {
            if (
              row.tyc_orders[i].customer_phone &&
              this.callPhone1.indexOf(row.tyc_orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.tyc_orders[i].customer_phone);
            }
            if (
              row.tyc_orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.tyc_orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.tyc_orders[i].corporate_phone);
            }
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    loadCategory_id() {
      this.$axios
        .get("api/schedule/getcate")
        .then(({ data }) => {
          if (data.code === 1) {
            this.category_idOptions = data.data;
          }
        })
        .catch();
    },
    loadSchedule_id(catid) {
      this.$axios
        .get("api/servicein/gettitlee?categoryId=" + catid)
        .then(({ data }) => {
          if (data.code === 1) {
            this.schedule_idOptions = data.data;
          }
        })
        .catch();
    },
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        // if (items[i].type.indexOf('image') !== -1) {
        file = items[i].getAsFile();
        // break
        // }
      }
      // if (!file) {
      //   this.$message.error('粘贴内容非图片')
      //   return
      // }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
        return;
      }
      this.$refs.uploadMutiple.handleStart(file); // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit(); // 提交图片上传队列
    },
    handleRemove(file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1);
        }
      });
      this.fileList = fileList;
      this.change = true;
    },
    handlePictureCardPreview(file) {
      this.fileNameList = file.name;
    },
    handleAvatarChange(res, file) {
      this.fileList = file;
      this.change = true;
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid });
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt100M = file.size / (1024 * 100) < 100;

      // if (!isJPG) {
      //   this.$message.error('上传图片格式为JPG或PNG!')
      //   return
      // }
      if (!isLt100M) {
        this.$message.error("上传总大小不能超过 100MB!");
        return false;
      }
      // return isJPG && isLt2M
    },
    getCustomer(val) {
      if (val.length === 0) return false;
      this.$axios
        .get("api/servicein/getcustomer?user_id=" + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.customerData = data.data;
          }
        })
        .catch();
    },
    getExp(val) {
      if (val.length === 0) return false;
      this.$axios
        .get("api/servicein/getexp?exp_num=" + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.expData = data.data;
          }
        })
        .catch();
    },
    getOrder(val) {
      if (val.length === 0) return false;
      this.$axios
        .get("api/servicein/getorder?order_num=" + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.orderData = data.data;
          }
        })
        .catch();
    },
    serviceIn() {
      this.serviceInDrawer = true;
      this.loadShare();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.$refs.serviceInForm.resetFields();
          this.orderData = null;
          this.expData = null;
          this.customerData = null;
          this.fileList = [];
          this.needUrl = [];
          this.change = false;
          done();
        })
        .catch((_) => { });
    },
    handleClose_edit(done) {
      // this.$confirm('确认关闭？')
      // .then(_ => {
      this.$refs.editForm.resetFields();
      this.orderData = null;
      this.expData = null;
      this.customerData = null;
      this.fileList = [];
      this.needUrl = [];
      this.change = false;
      this.categoryIdOptions = [];
      this.searchCompanies = [];
      this.placeOptions = [];
      done();
      // })
      // .catch(_ => {})
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        this.searchArrItemCompanys(query);
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany_a?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    loadCategory() {
      this.$axios
        .get("api/schedule/getcate")
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryIdOptions = data.data;
          }
        })
        .catch();
    },
    loadTitle(id, ifChange) {
      this.titleIdOptions = [];
      this.serviceInForm.title = [];
      this.serviceInForm.detail_in = "";
      if (ifChange) {
        this.editForm.title = [];
        this.editForm.detail_in = "";
      }
      if (id) {
        this.$axios
          .get("api/servicein/gettitle?cate_id=" + id)
          .then(({ data }) => {
            if (data.code === 1) {
              this.titleIdOptions = data.data;
            }
          })
          .catch();
      }
    },
    changeTitle(val) {
      this.watchDetail_in_arr = [];
      val.map((item) => {
        this.titleIdOptions.map((i) => {
          if (i.id === item) {
            this.watchDetail_in_arr.push(i.title + ":" + "\n");
          }
        });
      });
    },
    changeTitle_edit(val) {
      this.watchDetail_in_arr_edit = [];
      val.map((item) => {
        this.titleIdOptions.map((i) => {
          if (i.id === item) {
            this.watchDetail_in_arr_edit.push(i.title + ":" + "\n");
          }
        });
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.serviceInForm.file = this.needUrl;
          this.$axios
            .post("api/servicein/store", this.serviceInForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.$refs.serviceInForm.resetFields();
                this.orderData = null;
                this.expData = null;
                this.customerData = null;
                this.needUrl = [];
                this.fileList = [];
                this.serviceInDrawer = false;
                this.change = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    openCompanyCom(row) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyComId = row.company_id;
      });
    },
    loadTable() {
      this.$axios
        .get("api/servicein/index?page=" + this.npage + "&perPage=" + this.valuePerPage, {
          params: this.searchForm,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.serviceInData = data.data.data;
            this.total = data.data.total;
            this.header = data.count;
          }
        })
        .catch();
    },
    loadTableHyperf() {
      this.$axios
        .get(
          this.hyperfHost +
          "/v1/api/servicein/index?page=" +
          this.npage +
          "&perPage=" +
          this.valuePerPage,
          {
            params: this.searchForm,
          }
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.serviceInData = data.data.data;
            this.total = data.data.total;
            this.header = data.count;
          }
        })
        .catch();
    },
    loadCount() {
      this.$axios
        .get(this.hyperfHost + "/v1/api/servicein/count", {
          params: this.searchForm,
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.header = data.count;
          }
        })
        .catch();
    },
    handleSizeChange(val) {
      this.valuePerPage = val;
      this.loadTable();
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.nowPage = val;
      this.loadTable();
    },
    openEdit(row) {
      // console.log(row.schedule)
      this.idForEdit = row.id;
      this.searchCompanies.push(row.company);
      this.editForm.company_id = row.company_id;
      this.editForm.order_num = row.order_num;
      this.editForm.exp_num = row.exp_num;
      this.editForm.customer_name = row.customer ? row.customer.name : "暂无";
      this.editForm.completed_at = row.completed_at;
      this.editForm.type = row.type === "n" ? 0 : true;
      this.editForm.urgent = row.urgent;
      this.editForm.easy = row.easy;
      this.categoryIdOptions.push(row.category);
      this.editForm.categoryId = row.categoryId;
      this.titleIdOptions = row.schedule;
      this.editForm.title = row.title;
      this.editForm.detail_in = row.detail_in;
      this.editForm.detail_out = row.detail_out;
      if (row.share_id) {
        // this.shareOptions = row.share;
        this.loadShare();
        this.editForm.share_id = row.share_id;
      }
      if (row.doner_id) {
        // this.adminUserOptions.push(row.donner);
        this.loadAdminUser();
        this.editForm.doner_id = row.doner_id;
      }
      if (row.type === "w") {
        if (row.doner_id_w) {
          // this.adminUserOptions_w.push(row.donner_w);
          this.loadAdminUserForW();
          this.editForm.doner_id_w = row.doner_id_w;
        }
        if (row.address) {
          this.placeOptions.push(row.place);
          this.editForm.address = row.address;
        }
      }
      this.editForm.remark = row.remark;
      this.fileList = row.screen;
      this.needUrl = row.screen;
      this.loadTitle(this.editForm.categoryId);
      this.editForm.exp_company = row.exp_company;
      this.editForm.exp_phone = row.exp_phone;
      this.editDrawer = true;
    },
    submitForm_edit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editForm.file = this.needUrl;
          this.editForm.id = this.idForEdit;
          var oldId = this.fileList.map((item) => {
            return item.id;
          });
          this.editForm.oldId = oldId;
          this.editForm.change = this.change;
          this.$axios
            .put("api/outdis/edit", this.editForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.editDrawer = false;
                this.change = false;
                this.needUrl = [];
                this.fileList = [];
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    openDistribute(row) {
      this.distributeForm.id = row.id;
      this.searchCompanies.push(row.company);
      this.distributeForm.company_id = row.company_id;
      this.distributeForm.order_num = row.order_num;
      this.distributeForm.exp_num = row.exp_num;
      this.distributeForm.customer_name = row.customer ? row.customer.name : "暂无";
      this.distributeForm.completed_at = row.completed_at;
      this.distributeForm.type = row.type === "n" ? 0 : true;
      this.distributeForm.urgent = row.urgent;
      this.distributeForm.easy = row.easy;
      this.categoryIdOptions.push(row.category);

      this.distributeForm.categoryId = row.categoryId;
      this.titleIdOptions = row.schedule;
      this.distributeForm.title = row.title;
      this.distributeForm.detail_in = row.detail_in;
      this.distributeForm.detail_out = row.detail_out;
      if (row.share_id) {
        // this.shareOptions = row.share;
        this.loadShare();
        this.distributeForm.share_id = row.share_id;
      }
      if (row.doner_id) {
        // this.adminUserOptions.push(row.donner);
        this.loadAdminUser();
        this.distributeForm.doner_id = row.doner_id;

        // console.log('111'+ this.distributeForm.doner_id);
      }
      if (row.type === "w") {
        if (row.doner_id_w) {
          // this.adminUserOptions_w.push(row.donner_w);
          this.loadAdminUserForW();
          this.distributeForm.doner_id_w = row.doner_id_w;
        }
        if (row.address) {
          this.placeOptions.push(row.place);
          this.distributeForm.address = row.address;
        }
      }
      this.distributeForm.remark = row.remark;
      this.distributeDrawer = true;
    },
    handleCloseDis(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          // this.$refs.distributeForm.resetFields()
          // this.adminUserOptions = [];
          this.diserOptions = [];
          this.resetForm("distributeForm");
          this.distributeForm.doner_id = "";
          this.distributeForm.doner_id_w = "";
          this.distributeForm.address = "";
          this.categoryIdOptions = [];
          this.searchCompanies = [];
          this.placeOptions = [];
          done();
        })
        .catch((_) => { });
    },
    loadAdminUser() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions = data.data;
            // console.log(this.adminUserOptions);
          }
        })
        .catch();
    },
    loadAdminUser_a() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions_a = data.data;
          }
        })
        .catch();
    },
    loadAdminUser_a_w() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions_a_w = data.data;
          }
        })
        .catch();
    },
    loadAdminUserForW() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions_w = data.data;
          }
        })
        .catch();
    },
    loadShare() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.shareOptions = data.data;
          }
        })
        .catch();
    },
    loadTypeiner() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.typeinerOptions = data.data;
          }
        })
        .catch();
    },
    loadDoner() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.donerOptions = data.data;
          }
        })
        .catch();
    },
    loadDiser() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.diserOptions = data.data;
          }
        })
        .catch();
    },
    loadSharer() {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.sharerOptions = data.data;
          }
        })
        .catch();
    },
    loadPlace() {
      this.$axios
        .get("api/outdis/getplace")
        .then(({ data }) => {
          if (data.code === 1) {
            this.placeOptions = data.data;
          }
        })
        .catch();
    },
    submitDisForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("api/ysy/outdis/distribute", this.distributeForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.$refs.distributeForm.resetFields();
                this.distributeForm.doner_id = "";
                this.distributeForm.doner_id_w = "";
                this.distributeForm.address = "";
                this.distributeDrawer = false;
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    searchRemoteCompanyMethodS(query) {
      if (query !== "") {
        this.searchLoading = true;
        this.searchArrItemCompanysx(query);
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.searchCompaniesx = [];
      }
    },
    searchArrItemCompanysx(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompaniesx = data.data.companies;
        }
      });
    },
    toSearch(val) {
      this.npage = 1;
      this.loadTable();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    doSearch() {
      this.npage = 1;
      this.loadTable();
    },
    toLoadTable() {
      this.npage = 1;
      this.loadTable();
    },
    clearNot(val) {
      if (!val) {
        this.serviceInForm.doner_id_w = "";
        this.serviceInForm.address = "";
      }
    },
    clearNot_edit(val) {
      if (!val) {
        this.editForm.doner_id_w = "";
        this.editForm.address = "";
      }
    },
    doSomeThing(val) {
      if (!val) {
        this.serviceInForm.doner_id = "";
        this.serviceInForm.doner_id_n = "";
        this.serviceInForm.doner_id_w = "";
        this.serviceInForm.address = "";
      }
    },
    doSomeThing_edit(val) {
      if (!val) {
        this.editForm.doner_id = "";
        this.editForm.doner_id_w = "";
        this.editForm.address = "";
      }
    },
    getComUser(val) {
      if (val) {
        this.$axios.get("api/servicein/getcomuser?company_id=" + val).then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.serviceInForm.customer_name = data.data[1];
            this.serviceInForm.customer_id = data.data[0];
          }
        });
      }
    },
    saveChange(formName, id) {
      if (id) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addAddressForm.id = id;
            this.$axios
              .post("api/servicein/singleadddoner", this.addAddressForm)
              .then((res) => {
                const { data } = res;
                if (data.code === 1) {
                  var myEvent = new Event("click");
                  document.dispatchEvent(myEvent);
                  this.$message.success(data.msg);
                  this.loadTable();
                } else {
                  this.$message.error(data.msg);
                }
              });
          } else {
            return false;
          }
        });
      }
    },
    saveChange_aw(formName, id) {
      if (id) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addAddressFormW.id = id;
            this.$axios
              .post("api/servicein/singleadddonerw", this.addAddressFormW)
              .then((res) => {
                const { data } = res;
                if (data.code === 1) {
                  var myEvent = new Event("click");
                  document.dispatchEvent(myEvent);
                  this.$message.success(data.msg);
                  this.loadTable();
                } else {
                  this.$message.error(data.msg);
                }
              });
          } else {
            return false;
          }
        });
      }
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
  },
  watch: {
    watchDetail_in_arr: function (n, old) {
      this.serviceInForm.detail_in = n.join("");
      this.serviceInForm.detail_out = n.join("");
    },
    watchDetail_in_arr_edit: function (n, old) {
      this.editForm.detail_in = n.join("");
      this.editForm.detail_out = n.join("");
    },
  },
  mounted() {
    this.loadTable();
    // this.loadTableHyperf()
    // this.loadCount()
  },
};
</script>
<style scoped>
.service_in {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}




.service_in>>>.el-collapse-item__wrap {
  position: fixed;
  width: -webkit-fill-available;
  z-index: 222 !important;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 15px;
  text-align: right;
}

.middle-table {
  z-index: 1;
}




.el-drawer__wrapper>>>.el-drawer {
  overflow-y: auto;
}

.notOver {
  display: block;
  width: 3rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#servicein>>>.el-collapse-item__wrap {
  will-change: height;
  background-color: #fff;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: none;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
  color: #334;
  font-weight: 700;
}

.item-title {
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
}

.item-row {
  margin-top: 0.2rem;
}

/* .item-row :nth-child(1) {
  text-align: right
} */
</style>



// WEBPACK FOOTER //
// src/pages/schedule/ServiceIn.vue